export default "__VITE_ASSET__CAIORzaF__"